var exports = {
  "k": "xdde3148b--ad7bb4--container",
  "Q": "xdde3148b--ad7bb4--content",
};

module.exports = exports;
